<template>
    <div class="row" v-if="form.id">
        <div class="col-md-10">
            <div class="row mt-2">
                <div class="col-md-5 mt-2">
                    <label class="form-label">Allow bookings to be placed no later than</label>
                    <select class="form-select" :class="hasError('order_creation_before_interval_id') ? 'is-invalid' : ''" v-model="form.order_creation_before_interval_id">
                        <option v-for="interval in reminderIntervals" :value="interval.id">{{ interval.title }}
                        </option>
                    </select>
                    <label class="form-label">before the cleaning</label>
                </div>
                <div class="col-md-5 mt-2">
                    <label class="form-label">Allow bookings to be rescheduled no later than</label>
                    <select class="form-select" :class="hasError('order_reschedule_interval_id') ? 'is-invalid' : ''" v-model="form.order_reschedule_interval_id">
                        <option v-for="interval in reminderIntervals" :value="interval.id">{{ interval.title }}</option>
                    </select>
                    <label class="form-label">before the cleaning</label>
                </div>
                <hr class="mt-1">
            </div>
            <div class="row mt-2">
                <div class="col-md-4 mt-2">
                    <label class="form-label">Sort extras in checkout by</label>
                    <select class="form-select" :class="hasError('extra_services_sort_id') ? 'is-invalid' : ''" v-model="form.extra_services_sort_id">
                        <option v-for="sort in extraSorts" :value="sort.id">{{ sort.title }}</option>
                    </select>
                </div>
                <hr class="mt-4">
            </div>
            <div class="row mt-2">
                <div class="col-md-3 mt-2">
                    <label class="form-label">Duration of pending status, hours</label>
                    <input
                        type="text" v-model="form.time_for_pending_status"
                        class="form-control"
                        :class="hasError('time_for_pending_status') ? 'is-invalid' : ''"
                        id="time_for_pending_status"
                        name="time_for_pending_status"
                        max="9999"
                        onkeypress="validateNumAndSpecChars(event)"
                    >
                    <span class="mt-2 text-danger" v-if="hasError('time_for_pending_status')">
                                {{ getError('time_for_pending_status') }}
                            </span>
                    <div class="mt-2">
                        <span class="form-label" style="color: #525f7f; display: block;">
                            When customer reaches Payment step in Checkout but doesn’t pay nor Cart URL is copied</span>
                    </div>
                </div>
                <div class="col-md-3 mt-2">
                    <label class="form-label">Duration of reserved status, hours</label>
                    <input
                        type="text" v-model="form.time_for_reserved_status"
                        class="form-control"
                        :class="hasError('time_for_reserved_status') ? 'is-invalid' : ''"
                        id="time_for_reserved_status"
                        name="time_for_reserved_status"
                        max="9999"
                        onkeypress="validateNumAndSpecChars(event)"
                    >
                    <span class="mt-2 text-danger" v-if="hasError('time_for_reserved_status')">
                                {{ getError('time_for_reserved_status') }}
                            </span>
                    <div class="mt-2">
                        <span class="form-label" style="color: #525f7f; display: block;">
                            When Cart URL is copied
                        </span>
                    </div>
                </div>
                <hr class="mt-4">
            </div>
            <div class="row mt-2">
                <div class="col-md-3 mt-2">
                    <label class="form-label">Max image width (px)</label>
                    <input
                        type="text" v-model="form.max_image_width"
                        v-on:keypress="onlyNumbers"
                        class="form-control float-start"
                        :class="hasError('max_image_width') ? 'is-invalid' : ''"
                        :maxlength="maxLength"
                        id="max_image_width"
                        name="max_image_width"
                    >
                    <div class="clear"></div>
                    <span
                        class="mt-2 text-danger"
                        v-if="hasError('max_image_width')">
                                    {{ getError('max_image_width') }}
                            </span>
                </div>
                <div class="col-md-3 mt-2">
                    <label class="form-label">Max image height (px)</label>
                    <input
                        type="text" v-model="form.max_image_height"
                        v-on:keypress="onlyNumbers"
                        class="form-control float-start"
                        :class="hasError('max_image_height') ? 'is-invalid' : ''"
                        :maxlength="maxLength"
                        id="max_image_height"
                        name="max_image_height"
                    >
                    <div class="clear"></div>
                    <span
                        class="mt-2 text-danger"
                        v-if="hasError('max_image_height')">
                                    {{ getError('max_image_height') }}
                            </span>
                </div>
                <hr class="mt-4">
            </div>
            <div class="row mt-2">
                <div class="col-md-3 mt-2">
                    <label class="form-label">Minimum order incl. extras, €</label>
                    <input
                        type="text" v-model="form.minimum_order"
                        class="form-control"
                        :class="hasError('minimum_order') ? 'is-invalid' : ''"
                        id="minimum_order"
                        name="minimum_order"
                        max="9999"
                        onkeypress="validateNumAndSpecChars(event)"
                    >
                    <span class="mt-2 text-danger" v-if="hasError('minimum_order')">
                                {{ getError('minimum_order') }}
                            </span>
                    <input type="checkbox" :checked="showServicesSearch" @click="showServicesSearch = !showServicesSearch" id="show-service-search">
                    <label class="form-label" for="show-service-search">Different for certain services</label>
                </div>
            </div>
            <div class="row mt-2" v-if="showServicesSearch">
                <div class="col-md-6 mt-2">
                    <div v-if="selectedServices.length">
                        <div class="row mt-2 font-bold">
                            <div class="col-md-5">Service title</div>
                            <div class="col-md-5">Min. order incl. extras, €</div>
                            <div class="col-md-2"></div>
                        </div>

                        <div class="row mt-2" v-for="service in selectedServices" :key="service.id">
                            <div class="col-md-5">{{ service.name }}</div>
                            <div class="col-md-5">
                                <input type="text"
                                       class="form-control"
                                       :class="hasError('service_minimum_order') ? 'is-invalid' : ''"
                                       id="service_minimum_order"
                                       name="service_minimum_order"
                                       max="9999"
                                       onkeypress="validateNumAndSpecChars(event)"
                                       :value="service.min_order"
                                       @input="e => handleInput(e, service.id)"
                                >
                            </div>
                            <div class="col-md-2">
                                <a class="btn btn-square btn-danger rounded-circle p-2 ms-2" @click="removeService(service.id)"><span class="svg-icon"><i class="bi bi-archive"></i></span></a>
                            </div>
                        </div>
                    </div>
                    <input class="form-control mt-4 autocomplete" ref="autocomplete" id="autocomplete" placeholder="Search..." @keyup="searchServices($event)">
                    <div id="output" v-if="showSearchSuggestions">
                        <ul>
                            <li v-for="item in servicesFiltered" @click="selectService(item.id)">{{ item.name }}</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="row mt-2">
                <hr class="mt-4">
                <div class="col-md-12 mt-2 pb-3">
                    <button type="submit" class="btn btn-primary float-end" @click="updateSettings">Save</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Form from "../helpers/Form";
import Notification from "../helpers/Notification";

export default {
    mixins: [Form],
    props: {},
    data() {
        return {
            // form data (current form values)
            form: {},
            extraSorts :[],
            reminderIntervals: [],
            countries: [],
            maxLength: 4,
            services: [],
            allServices: [],
            showServicesSearch: false,
            servicesFiltered: [],
            showSearchSuggestions: false,
            selectedServices: [],
            removeServices: [],
        };
    },
    watch: {
        success: function (value, oldValue) {
            if (value) {
                this.getSettings();
            }
        },
    },
    methods: {
        getExtrasSorting(){
            axios.get('/api/admin/settings/get-extras-sorting'
            )
                .then(res => {
                    this.extraSorts = res.data;
                })
                .catch((error) => {
                    console.log(error.response.data.message);
                });
        },
        getIntervals() {
            axios.get('/api/time-intervals?withZero=true'
            )
                .then(res => {
                    this.reminderIntervals = res.data.data;
                })
                .catch((error) => {
                    console.log(error.response.data.message);
                });
        },
        getCountries() {
            axios.get('/api/countries'
            )
                .then(res => {
                    this.countries = res.data;
                })
                .catch((error) => {
                    console.log(error.response.data.message);
                });
        },
        getSettings() {
            this.errors = {};
            axios.get('/api/admin/settings?type=booking').then(res => {
                    this.form = res.data.data;

                    if (this.form.selected_services.length) {
                        this.selectedServices = this.form.selected_services;
                        this.showServicesSearch = true;
                        this.reloadAutocomplete();
                    }
                }
            );
        },
        updateSettings() {
            this.form.service_minimum_order = this.showServicesSearch ? this.selectedServices: [];
            this.form.remove_services = this.removeServices;

            this.form.type = 'booking'

            axios.put('/api/admin/settings-booking', this.form)
                .then(res => {
                    Notification.methods.success(res.data.message);
                    this.errors = {};
                })
                .catch((error) => {
                    if(error && error.response.status === 422) {
                        this.setErrors(error.response.data.errors);
                    }else {
                        this.onFailure(error.response.data.message);
                    }
                });
        },
        onlyNumbers(e) {
            e = (e) ? e : window.event;
            let charCode = (e.which) ? e.which : e.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                e.preventDefault();
            } else {
                return true;
            }
        },
        getServices() {
            axios.get('/api/services')
                .then(res => {
                    this.services = res.data;
                    this.allServices = this.services;
                })
                .catch((error) => {
                    console.log(error.response.data.message);
                });
        },
        searchServices(e) {
            const value = e.target.value;

            if (value.length < 2) {
                this.showSearchSuggestions = false;
                return;
            }

            this.servicesFiltered = this.services.filter((item) => item.name.toLowerCase().indexOf(value.toLowerCase()) !== -1 && !this.selectedServices.some(service => service.name === item.name));
            this.showSearchSuggestions = this.servicesFiltered.length;
        },
        selectService(id) {
            this.selectedServices.push(this.services.filter(i => i.id === id)[0]);
            this.removeServices.splice(this.removeServices.findIndex(itemId => itemId === id), 1);

            this.clearSuggestions();
            this.reloadAutocomplete();
        },
        reloadAutocomplete() {
            const existingIds = this.selectedServices.map(i => i.id);
            this.services = this.allServices.filter(i => !existingIds.includes(i.id));
        },
        clearSuggestions() {
            this.showSearchSuggestions = false;
            this.$refs.autocomplete.value = '';
        },
        handleInput(e, idx) {
            this.selectedServices = this.selectedServices.map((item) => item.id === idx ? {...item, min_order: e.target.value} : item);
        },
        removeService(id) {
            this.removeServices.push(id);
            this.selectedServices.splice(this.selectedServices.findIndex(item => item.id === id), 1);
            this.reloadAutocomplete();
        }
    },
    mounted() {
        //table get data
        this.getCountries();
        this.getIntervals();
        this.getExtrasSorting();
        this.getServices();
        this.getSettings();
    }
}
</script>

<style scoped>
.form-label {
    margin-left: 5px;
}

.modal-mask {
    position: fixed;
    z-index: 1000;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    overflow: scroll;
}

.fade-enter-active,
.fade-leave-active {
    transition: all 0.4s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
#output {
    position: relative;
    background: #fff;
    box-shadow: 0 2px 6px #ccc;
    border-radius: 5px;
    z-index: 1;
}
#output ul {
    list-style: none;
    padding: 0;
    margin: 0;
}
#output ul li {
    padding: 1em;
}
#output ul li:hover {
    background: #efefef;
    cursor: pointer;
}
</style>
